import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { CardDetailComponent } from './card-detail/card-detail.component';
import { CardTransactionComponent } from './card-transaction/card-transaction.component';
import { TermsComponent } from './terms/terms.component';

const routes: Routes = [
  { path: '', redirectTo:'./login/login.component', pathMatch: 'full' },
  { path: 'login', component: LoginComponent,   pathMatch: 'full' },
  { path: 'login/virtual-card', component: LoginComponent,   pathMatch: 'full' },
  { path: 'login/physical-card', component: LoginComponent,   pathMatch: 'full' },
  { path: 'login/voucher-code', component: LoginComponent,   pathMatch: 'full' },
  { path: 'home',  component: HomeComponent,    pathMatch: 'full' },
  { path: 'card-detail/:id',  component: CardDetailComponent, pathMatch: 'full' },
  { path: 'card-transaction/:id',  component: CardTransactionComponent, pathMatch: 'full' },
  { path: 'terms', component: TermsComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
